/**
 * @package  	Cavalry_Infatree_Theme
 * @copyright	Copyright (c) 2021 Infantree (https://infantree.com/)
 * @version  	1.0.0
 *
 */

if (typeof $ === "undefined") {
  var $ = jQuery;
}

window.onload = filterScroll;

/*****************************
 * Vanilla JS functions
 *****************************/
// addHeadingNonBreakingSpace();
detectScrollbarWidth();
// END Vanilla JS

/*****************************
 * jQuery Ready
 *****************************/
$(document).ready(function () {
  let siteModal = sessionStorage.getItem("siteModal");

  setTimeout(function () {
    if ($(".site-header--alert").length) {
      $(".site-header--alert").addClass("is-visible");
    }
  }, 1000);

  setTimeout(function () {
    if (!siteModal && $(".site-modal").length) {
      $(".site-modal").addClass("is-visible");
    }
  }, 1500);

  $(".wv-page-header__gallery").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 750,
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000,
    fade: true,
    rows: false,
    cssEase: "ease",
    pauseOnFocus: false,
    pauseOnHover: false,
  });

  if ($(".site-modal").length) {
    $(".site-modal__close").on("click", function (e) {
      $(".site-modal").removeClass("is-visible");

      sessionStorage.setItem("siteModal", true);
    });
  }
});

// END jQuery Ready
function detectScrollbarWidth() {
  /* Detect scrollbar width to properly center full- and wide-width elements */
  let root = document.documentElement;
  var outside = document.createElement("div");
  var inside = document.createElement("div");

  outside.style.width = inside.style.width = "100%";
  outside.style.overflow = "scroll";
  document.body.appendChild(outside).appendChild(inside);

  var scrollbarWidth = outside.offsetWidth - inside.offsetWidth;

  outside.parentNode.removeChild(outside);
  root.style.setProperty("--scrollbar-width", scrollbarWidth + "px");
}

function addHeadingNonBreakingSpace() {
  var headings = document.querySelectorAll("h1, h2, h3, h4, h5, h6");

  headings.forEach(function (head, index) {
    let str = head.textContent;
    let firstSection = str.substring(0, str.lastIndexOf(" ") + 1);
    let lastSection = str.substring(str.lastIndexOf(" ") + 1, str.length);

    firstSection = firstSection.trim();

    let newStr = firstSection + "\u00a0" + lastSection;

    head.innerHTML = newStr;
  });
}

function filterScroll() {
  var search = window.location.search;

  if (search.includes("sf_paged")) {
    document.querySelector(".block--wv-careers").scrollIntoView({
      behavior: "smooth",
    });
  }
}
